export default function calculateRates(landValue, base, adValoremRate, minimum, rebate) {
    let adValorem = Math.max((landValue * adValoremRate) - rebate, minimum);
    return adValorem + base;
}